import useSWR from "swr";
import qs from "qs";
import apiClient from "@/utils/apiClient";

export const useEntries = (filters = {}) => {
  let query = qs.stringify({
    populate: "*",
    filters: {
      ...filters,
    },
  });
  const fetcher = (url) => apiClient.get(url).then((res) => res.data);

  const { data, error, mutate } = useSWR(`/api/entradas?${query}`, fetcher);

  return { data, isLoading: !error && !data, error, mutate };
};
